import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Boxes from '../components/Boxes';
import { getDeviceType, updateMetaTags } from '../utils/deviceDetection';
import '../App.css';

// WARNING: This is cloaking simulation for demo purposes only. 
// Cloaking is against Google SEO guidelines and can result in a site being banned.

function BahsobetPage() {
  const [deviceType, setDeviceType] = useState('desktop');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Detect device type and update meta tags
    const detectedDeviceType = getDeviceType();
    setDeviceType(detectedDeviceType);
    updateMetaTags(detectedDeviceType);
    
    // Simulate loading delay for demo purposes
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, []);

  if (isLoading) {
    return (
      <div className="loading">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="App">
      <Header deviceType={deviceType} />
      <main className="mehdi-kardesim">
        <Boxes deviceType={deviceType} />
      </main>
      
      <footer className="footer">
        <div className="footer-content">
          <p>
            <strong>Reklam vermek istiyorsanız lütfen benimle iletişime geçin.  tg: @areftherat</strong>.
          </p>
          <p className="footer-warning">
            ⚠️ <strong>UYARI:</strong> Reklam vermek istiyorsanız lütfen benimle iletişime geçin.<strong> tg: @areftherat</strong>
          </p>
        </div>
      </footer>
    </div>
  );
}

export default BahsobetPage;

